export enum Errors {
    TRUCK_NOT_FOUND = 'truck.not.found',
    INVALID_PAGBEM_CARD = 'pagbem.card.invalid',
}
